<template>
  <div class="checkout-divider" />
</template>

<style scoped lang="scss">
.checkout-divider {
  border-top: 1px solid $color-base-black-10;
  margin: 4px 0;
}
</style>
